// extracted by mini-css-extract-plugin
export default {"links":"Links_links__Z9+D+","links--mobile":"Links_links--mobile__LeB0s"};